// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__WilaL","title":"ClientCherryInfo_title__3Q2Cw","itemText":"ClientCherryInfo_itemText__1yHZJ"};